module.exports = __webpack_public_path__ + "img/Schminke.389c70c5.svg";